export function attribute(resource, name) {
    return resource[name];
}
//# sourceMappingURL=resources.js.map